import { getCookie } from 'eco-design-micro/utils-base/getCookie';

const tokenKeyA = 'userInfo';
export const getWebToken = () => {
    const userInfoA = getCookie(tokenKeyA);
    if (!userInfoA) {
        return '';
    }
    try {
        const userInfoB = decodeURIComponent(userInfoA);
        const userInfoC = JSON.parse(userInfoB) || {};
        return userInfoC.token || '';
    } catch (error) {}
    return '';
};

export const getIsLogin = () => {
    const tokenA = getWebToken();
    return !!tokenA;
};

export const loginUser = () => {
    const userInfoA = getCookie(tokenKeyA);
    if (!userInfoA) {
        return {};
    }
    try {
        const userInfoB = decodeURIComponent(userInfoA);
        const userInfoC = JSON.parse(userInfoB) || {};
        return userInfoC;
    } catch (error) {}
    return {};
};
